import LogApi from '@/api/log';
import Taro, { Current } from '@tarojs/taro';
import { formatDate, detectDeviceModel } from '@/utils';
// import Glog from '@gh/glog';

const MobileDetect = require('mobile-detect');

/**
 * 埋点
 */
export const addLog = (params: any) => {
  const app: any = Current.app;
  LogApi.addLog({
    // 公共属性
    ...app.globalData.commonProps,
    time: formatDate.format(new Date().getTime(), 'YYYY-MM-DD hh:mm:ss'),
    ...params
  });
};

/**
 * pv埋点
 */
export const pageView = ({
  title = '', // 页面标题
  utm_campaign = '', // 广告名称
  utm_source = '', // 广告来源
  utm_medium = '', // 广告媒介
  utm_content = '', // 广告内容
  aid = 1,
  eid = 1
}) => {
  const length = Taro.getCurrentPages().length;
  addLog({
    aid,
    eid,
    extend: {
      title,
      url: window.location.href,
      url_path: window.location.pathname,
      referrer: length > 1 ? Taro.getCurrentPages()[length - 1].path : '',
      utm_campaign,
      utm_source,
      utm_medium,
      utm_content
    }
  });
};

// export const reportAndLog = (content: string, type: number) => {
//   const md = new MobileDetect(window.navigator.userAgent);
//   Glog.log(content, type, true);
//   Glog.report({
//     incrementalReport: true,
//     immediate: true,
//     systemInfo: {
//       ['app-name']: '',
//       ['app-version']: '',
//       ['os-name']: 'H5',
//       ['model']: detectDeviceModel(),
//       os: md.os(),
//       uid: '',
//       ['device-id']: ''
//     }
//   });
// };
